import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function ToolbarPopover({
  title,
  placeholder,
  value,
  showRemove = false,
  onChange,
  onConfirm,
  onClose,
  onRemove,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.popover}>
      <p className={styles.title}>{title}</p>
      <div className={styles.row}>
        <input
          autoFocus
          type="text"
          className={styles.input}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onConfirm();
            }
            if (e.key === "Escape") onClose();
          }}
        />
        <button type="button" className={styles.confirm} onClick={onConfirm}>
          {t("richTextInput.confirm")}
        </button>
        <button type="button" className={styles.cancel} onClick={onClose}>
          ✕
        </button>
      </div>
      {showRemove && onRemove && (
        <button type="button" className={styles.remove} onClick={onRemove}>
          {t("richTextInput.link.remove")}
        </button>
      )}
    </div>
  );
}

export { ToolbarPopover };
